import BaseModelAPI from '../BaseModelAPI';

export default class ArchivedDocumentStatusList extends BaseModelAPI {

	static entity = 'archiveddocumentstatuslist'
	static entityName = 'archiveddocumentstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
